/*
 * Copyright (c) Nexign, JSC, 2022-2023.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Ilya Babanov
 * @author Evgeniy Naumov
 * @version 1.25.1
 * @since 1.22.0
 */

import dayjs from 'dayjs';
import moment from 'moment';

import { getTimeZone } from '@modules/table/utils/getTimezone';
import { EFormatData } from '@pages/PageDashboard/types/widgetTypes';

import TableCellNoValue from '../TableCellNoValue';
import { CellDateSubtitle } from './styled';
import type { ITableCellDateProps } from './types';

// TODO change moment to dayjs

const DateCell = ({ date, enableSubtitle = true, format }: ITableCellDateProps) => {
    if (!date) {
        return <TableCellNoValue />;
    }

    return {
        [EFormatData.FullDateWithTime]: (
            <div className="table__tooltip-text">{moment(date).format(EFormatData.FullDateWithTime)}</div>
        ),
        [EFormatData.FullData]: (
            <>
                {moment(date).format(EFormatData.FullData)}
                {enableSubtitle && (
                    <CellDateSubtitle>
                        {moment(date).format(EFormatData.OnlyHourMinutes)} {getTimeZone(date)}
                    </CellDateSubtitle>
                )}
            </>
        ),
        [EFormatData.OnlyHourMinutes]: (
            <>
                {dayjs(date).format(EFormatData.OnlyHourMinutes)}
                {enableSubtitle && <CellDateSubtitle>{getTimeZone(date)}</CellDateSubtitle>}
            </>
        ),
    }[format];
};

export default DateCell;
